import clsx from "clsx";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Api } from "@/api";
import { setTextCity } from "~/utils";

import styles from "./index.module.scss";

export default function ClientComments() {
  const { products } = useSelector((state: any) => state.section);
  const { params: filterParams } = useSelector((state: any) => state.filter);
  const [clientComments, setClientComments]: any = useState([]);
  const { host } = useSelector((state: any) => state.params);
  const { domainData } = useSelector((state: any) => state.contacts);

  const router = useRouter();

  useEffect(() => {
    const getClientComments = async () => {
      setClientComments(
        await Api.server.getClientComments(
          window.location.pathname,
          filterParams.marka?.[0],
          filterParams.model?.[0],
          filterParams.kuzov?.[0],
          host,
          Boolean(router.query.reset),
        ),
      );
    };
    getClientComments();
  }, [products]);

  // @ts-ignore
  return clientComments?.length > 0 ? (
    <div className={clsx(styles.Comment)}>
      <div>
        {clientComments[0].TEXT.includes("сертифицирован") &&
        !clientComments[0].TEXT.includes("не сертифицирован") ? (
          <svg
            width="25"
            height="25"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C19.9939 15.5203 15.5203 19.9939 10 20ZM9.984 18H10C14.4167 17.9956 17.9942 14.4127 17.992 9.996C17.9898 5.57929 14.4087 2 9.992 2C5.57528 2 1.99421 5.57929 1.992 9.996C1.98979 14.4127 5.56729 17.9956 9.984 18ZM8 15L4 11L5.41 9.59L8 12.17L14.59 5.58L16 7L8 15Z"
              fill="#229317"
            />
          </svg>
        ) : (
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.9997 9.66634L14.9997 17.333M14.9997 20.333L14.9863 20.333M1.66634 14.9997C1.66634 7.63587 7.63588 1.66634 14.9997 1.66634C22.3635 1.66634 28.333 7.63587 28.333 14.9997C28.333 22.3635 22.3635 28.333 14.9997 28.333C7.63588 28.333 1.66634 22.3635 1.66634 14.9997Z"
              stroke="#FF584C"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      <div>
        {clientComments.map((comment: any) => (
          <div key={comment.NAME}>
            {comment.TEXT && (
              <div>{setTextCity(host, domainData, comment.TEXT)}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  ) : null;
}
